module.exports = __webpack_public_path__ + "img/Path 24@3x.99aedf78.png";